import SiteHeader from '../../components/feature/SiteHeader';
import ProgramsHero from './components/ProgramsHero';
import PricingCards from './components/PricingCards';
import ProgramsComparison from './components/ProgramsComparison';
import ProgramsFAQ from './components/ProgramsFAQ';
import ProgramsCTA from './components/ProgramsCTA';
import Footer from '../home/components/Footer';

export default function ProgramsPage() {
  return (
    <div className="min-h-screen flex flex-col">
      <SiteHeader />
      <main className="flex-1 pt-20">
        <ProgramsHero />
        <PricingCards />
        <ProgramsComparison />
        <ProgramsFAQ />
        <ProgramsCTA />
      </main>
      <Footer />
    </div>
  );
}
